/* KROSPER Ecosystem 1.0. Shared navigation, localization and media coordination. */
(() => {
  if (window.KrosperSystem) return;
  const root = document.documentElement;
  let inputMode = 'pointer';
  const openers = new WeakMap();
  const players = new Set();
  const onKey = event => {
    if (event.key === 'Tab') { inputMode = 'keyboard'; root.dataset.krInput = 'keyboard'; }
    if (event.key === 'Escape') document.querySelectorAll('.kr-nav details[open]').forEach(el => el.open = false);
  };
  document.addEventListener('keydown', onKey, true);
  document.addEventListener('pointerdown', () => { inputMode = 'pointer'; root.dataset.krInput = 'pointer'; }, true);
  function pauseOthers(current) {
    for (const audio of players) if (audio !== current && !audio.paused) audio.pause();
    document.querySelectorAll('audio, video').forEach(audio => {
      if (audio !== current && !audio.muted && !audio.paused) audio.pause();
    });
  }
  function registerMedia(audio) {
    if (!audio || players.has(audio)) return;
    players.add(audio);
    audio.addEventListener('play', () => pauseOthers(audio));
  }
  document.addEventListener('play', event => {
    const media = event.target;
    if (media.tagName === 'AUDIO' || (media.tagName === 'VIDEO' && !media.muted)) pauseOthers(media);
  }, true);
  function closeDialog(dialog) { if (dialog?.open) dialog.close(); }
  function openDialog(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    const cart = document.querySelector('cart-drawer.active');
    if (cart?.close) {
      const fromCart = cart.contains(opener);
      cart.close();
      if (fromCart) opener = document.querySelector('.kr-header-currency') || document.querySelector('#cart-icon-bubble');
    }
    document.querySelectorAll('.kr-dialog[open]').forEach(el => closeDialog(el));
    const search = dialog.querySelector('[data-kr-country-search]');
    if (search) { search.value = ''; filterCountries(search); }
    const returnTo = dialog.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search;
    openers.set(dialog, opener);
    opener?.setAttribute('aria-expanded', 'true');
    dialog.showModal();
    root.classList.add('kr-dialog-open');
    (dialog.querySelector('input:not([type="hidden"])') || dialog.querySelector('[data-kr-close]'))?.focus({ preventScroll: true });
    return true;
  }
  function filterCountries(input) {
    const dialog = input.closest('.kr-localization');
    const term = input.value.trim().toLocaleLowerCase();
    let count = 0;
    dialog.querySelectorAll('[data-kr-country]').forEach(button => {
      button.hidden = !button.dataset.search.toLocaleLowerCase().includes(term);
      if (!button.hidden) count++;
    });
    const empty = dialog.querySelector('[data-kr-country-empty]');
    if (empty) empty.hidden = count !== 0;
  }
  document.addEventListener('input', event => {
    if (event.target.matches('[data-kr-country-search]')) filterCountries(event.target);
  });
  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!dialog.matches?.('.kr-dialog')) return;
    const opener = openers.get(dialog);
    opener?.setAttribute('aria-expanded', 'false');
    // Native dialog restores focus. Pointer users keep focus without a stuck outline.
    root.dataset.krInput = inputMode;
    if (opener?.isConnected && !document.querySelector('.kr-dialog[open]')) opener.focus({ preventScroll: true });
    if (!document.querySelector('.kr-dialog[open]')) root.classList.remove('kr-dialog-open');
  }, true);
  document.addEventListener('click', event => {
    const currency = event.target.closest('[data-kr-currency-open], [data-market-open]');
    const trigger = currency || event.target.closest('[data-kr-open]');
    if (trigger) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = document.getElementById(currency ? 'kr-localization' : trigger.dataset.krOpen);
      if (openDialog(dialog, trigger)) event.preventDefault();
      return;
    }
    const route = event.target.closest('.kx-arsenal-menu a');
    if (route) closeDialog(route.closest('dialog'));
    const close = event.target.closest('[data-kr-close]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    if (event.target.matches('.kr-dialog')) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(event.target);
    }
    document.querySelectorAll('.kr-nav details[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('.kr-localization-form')) {
      pauseOthers(null);
      event.target.setAttribute('aria-busy', 'true');
      // Do not disable the submitter: its country_code must reach Shopify.
    }
  });
  window.addEventListener('pagehide', () => pauseOthers(null));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.kr-localization-form').forEach(form => form.removeAttribute('aria-busy'));
    document.querySelectorAll('.kr-dialog[open]').forEach(closeDialog);
  });
  class KrosperHeader extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const bar = this.querySelector('.kr-header');
      const measure = () => {
        if (!bar || !this.isConnected) return;
        const h = Math.ceil(bar.getBoundingClientRect().height);
        root.style.setProperty('--krosper-header-height', `${h}px`);
        root.style.setProperty('--kr-header-height', `${h}px`);
      };
      this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
      this.observer?.observe(bar);
      window.addEventListener('resize', measure, { passive: true, signal: this.abort.signal });
      this.addEventListener('click', event => {
        const link = event.target.closest('#cart-icon-bubble');
        const cart = document.querySelector('cart-drawer');
        if (link && cart?.open && !event.defaultPrevented) { event.preventDefault(); cart.open(link); }
        if (event.target.closest('.kr-menu-dialog a:not([data-kr-currency-open]):not([data-kr-open])')) closeDialog(this.querySelector('.kr-menu-dialog'));
      }, { signal: this.abort.signal });
      measure();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      this.querySelectorAll('dialog[open]').forEach(closeDialog);
    }
  }
  if (!customElements.get('kr-header')) customElements.define('kr-header', KrosperHeader);
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionInstances = new Map();
  function mountMotion(scope = document) {
    scope.querySelectorAll('[data-kr-motion]').forEach(el => {
      if (motionInstances.has(el)) return;
      const abort = new AbortController();
      const image = el.querySelector('img');
      const reset = () => { el.style.removeProperty('--kr-x'); el.style.removeProperty('--kr-y'); };
      el.addEventListener('pointermove', event => {
        if (!image || reduced.matches || event.pointerType !== 'mouse') return;
        const r = el.getBoundingClientRect();
        el.style.setProperty('--kr-x', `${((event.clientX - r.left) / r.width - .5) * 8}px`);
        el.style.setProperty('--kr-y', `${((event.clientY - r.top) / r.height - .5) * 8}px`);
      }, { passive: true, signal: abort.signal });
      el.addEventListener('pointerleave', reset, { signal: abort.signal });
      reduced.addEventListener('change', reset, { signal: abort.signal });
      motionInstances.set(el, () => { abort.abort(); reset(); motionInstances.delete(el); });
    });
  }
  function boot() { mountMotion(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', e => mountMotion(e.target));
  document.addEventListener('shopify:section:unload', e => {
    for (const [el, dispose] of motionInstances) if (e.target.contains(el)) dispose();
    e.target.querySelectorAll('audio,video').forEach(audio => { audio.pause(); players.delete(audio); });
    e.target.querySelectorAll('.kr-dialog[open]').forEach(closeDialog);
  });
  window.KrosperSystem = { openDialog, closeDialog, registerMedia, pauseOthers, unregisterMedia: audio => players.delete(audio) };
})();
